import { graphql } from "../gql";

export const createAskAutodorQueueMutationDoc = graphql(`
  mutation createAskAutodorQueue($input: CreateAskAutodorQueueInput!) {
    createAskAutodorQueue(input: $input) {
      ...AskAutodorQueueFragment
    }
  }
`);
